import { memo, useState } from "react";
import { Comment_Base } from "~/common/typescript/models/Comment";
import FormItemWrapper, { FormItem_Styles } from "~/components/common/FormItemWrapper/FormItemWrapper";
import { Button, Input } from "antd";
import { CommentAPIs } from "~/common/typescript/apis/CommentAPIs";
import { useAtom } from 'jotai';
import { commentsAtom } from "~/components/Map/Comment/CommentStore";

interface CommentItemUpdateFormProps {
  comment: Comment_Base;
  callbackSaved: Function;
}
const CommentItemUpdateForm = (props: CommentItemUpdateFormProps) => {
  const [comments, setComments] = useAtom(commentsAtom);
  const [editingTitle, setEditingTitle] = useState(props.comment.title);
  const [editingDescription, setEditingDescription] = useState(props.comment.description);

  const onClick_Save = async () => {
    await CommentAPIs.remote_updateComment(props.comment.id!, {
      title: editingTitle,
      description: editingDescription,
    });
    props.callbackSaved();
    setComments(comments.map((comment: Comment_Base) => {
      if (comment.id === props.comment.id) {
        return {
          ...comment,
          title: editingTitle,
          description: editingDescription,
        };
      }
      return comment;
    }));
  }

  return <>
    <FormItemWrapper label="Tiêu đề">
      <Input value={editingTitle} onChange={(e) => setEditingTitle(e.target.value)} />
    </FormItemWrapper>

    <FormItemWrapper label="Nội dung">
      <Input value={editingDescription} onChange={(e) => setEditingDescription(e.target.value)} />
    </FormItemWrapper>

    <FormItem_Styles.UI_ButtonGroup>
      <Button type="primary" onClick={onClick_Save}>Lưu</Button>
    </FormItem_Styles.UI_ButtonGroup>
  </>;
}

export default memo(CommentItemUpdateForm);